import { z } from "zod";

/**
 * Use this if you need to loop through all the options
 */
export const SystemValues = ["PORTAL", "CRM"] as const;
/**
 * Use this if you need to zod parse it
 */
export const SystemSchema = z.enum(SystemValues);
/**
 * Use this if you need to use the literal value
 */
export const System = SystemSchema.enum;
/**
 * Use this if you need to use the type
 */
export type System = z.infer<typeof SystemSchema>;
/**
 * Use this if you need to display a human-readable name
 */
export const SystemDisplayNames: Record<System, string> = {
  PORTAL: "Portal",
  CRM: "CRM",
} as const;
